import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {RaceService} from "@services";
import {Race} from "@model";

export const RaceDashboardFinishedResolver: ResolveFn<Observable<Race[]> | Race[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   raceService: RaceService = inject(RaceService)): Observable<Race[]> | Race[] => {
    return []; // TODO kduvnjak, replace with same fuctionality but on the level of events
    // return raceService.searchUserRaces(FindRacesRequest.createRacesFilterRequest({ raceEnd: <number>(new
    // Date()).getTime() }));
  }
